import {
  elevioUrls,
  getBackendDomain,
  resolveElevioUrlByEnvironment,
} from '../utils/apis';

export const snowcatAppId = 'com.elevio.dixa.kcs';
export const snowcatNamespace = 'snowcat';
export const snowcatPlatform = 'web';
export const snowcatUrl = getSnowcatUrl();

function getSnowcatUrl() {
  const backendDomain = getBackendDomain();
  const snowcatUrl = resolveElevioUrlByEnvironment(
    {
      production: elevioUrls.production.snowcat,
      staging: elevioUrls.staging.snowcat,
    },
    backendDomain,
  );

  return snowcatUrl;
}
